import { useEffect, useState } from 'react';
import type { Session } from '@supabase/auth-js';
import { useMutation } from '@tanstack/react-query';
import { getSharedSupabaseAuthClient } from '../lib/supabaseAuthClient';
import { api } from '../services/axiosConfig';
import { useConsent } from '../utils/consent';
import { readAcquisition } from '../utils/acquisition';
import { logger } from '../utils/logger';
import { assertCurrentAccountSession, getAccountSession, type AccountSession } from '../utils/accountSession';

export function AcquisitionAttachment() {
  const consent = useConsent();
  const [session, setSession] = useState<Session | null>(null);
  const mutation = useMutation({
    mutationFn: async ({ body, account }: { body: object; account: AccountSession }) => {
      assertCurrentAccountSession(account);
      return api.post('/user/acquisition', body);
    },
    retry: 2,
    onError: () => logger.warn('Acquisition attachment unavailable'),
  });
  const { mutate } = mutation;
  useEffect(() => {
    const auth = getSharedSupabaseAuthClient();
    let alive = true;
    let received = false;
    const { data: { subscription } } = auth.onAuthStateChange((_event, next) => {
      received = true;
      if (alive) setSession(next);
    });
    void auth.getSession().then(({ data }) => { if (alive && !received) setSession(data.session); });
    return () => { alive = false; subscription.unsubscribe(); };
  }, []);
  useEffect(() => {
    if (!session || !consent.decided) return;
    const acquisition = readAcquisition();
    mutate({ account: getAccountSession(), body: { ...consent,
      first: acquisition?.first || null, last: acquisition?.last || null } });
  }, [consent, mutate, session]);
  return null;
}
